module.exports = __webpack_public_path__ + "static/media/resource-5@2x.7c761874.jpg";